import React, { useMemo } from 'react';
import { ConnectionProvider, WalletProvider, useWallet as useWalletOriginal, useConnection as useConnectionOriginal } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from '@solana/web3.js';

// Import wallet adapter CSS
import '@solana/wallet-adapter-react-ui/styles.css';

// Default to mainnet
const network = WalletAdapterNetwork.Mainnet;

export const WalletContextProvider = ({ children }) => {
  // You can also provide a custom RPC endpoint
  const endpoint = useMemo(() => {
    // Priority: Helius RPC > Solana RPC > Public endpoint
    // Helius RPC is preferred for better performance and no rate limits
    const heliusRpcUrl = process.env.REACT_APP_HELIUS_RPC_URL;
    if (heliusRpcUrl) {
      console.log("🔗 Using Helius RPC endpoint:", heliusRpcUrl.replace(/api-key=[^&]+/, 'api-key=***'));
      console.log("🔗 Full Helius URL (first 50 chars):", heliusRpcUrl.substring(0, 50) + "...");
      return heliusRpcUrl;
    }
    
    // Fallback to Solana RPC if Helius not configured
    const solanaRpcUrl = process.env.REACT_APP_SOLANA_RPC_URL;
    if (solanaRpcUrl) {
      console.log("🔗 Using Solana RPC endpoint:", solanaRpcUrl);
      return solanaRpcUrl;
    }
    
    // Last resort: public mainnet endpoint (may be rate-limited)
    console.warn("⚠️ No RPC endpoint configured! Using public endpoint (may be rate-limited)");
    const publicEndpoint = clusterApiUrl(network);
    console.warn("⚠️ Public endpoint:", publicEndpoint);
    return publicEndpoint;
  }, []);

  // Configure wallets - only Phantom for now
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
    ],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          {children}
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};

// Re-export with explicit names to ensure webpack resolves them correctly
export const useWallet = useWalletOriginal;
export const useConnection = useConnectionOriginal;

